import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTransactionHistory } from "../../../../../store/actions/TranscationHistoryAction";
import pdfIcon from "../../../../../../src/assets/images/icons8-pdf-50.png";
import Loader from "../../../Common/Loader"; // ✅ Import loader
import { formatDate } from "../../../../../utils/dateUtils";
const TransactionHistory = () => {
  const dispatch = useDispatch();
  const { transactions } = useSelector((state) => state.transaction);
  const patientDetails = useSelector((state) => state.patients?.patientDetails);
  const [downloadingId, setDownloadingId] = useState(null);


  useEffect(() => {
    if (patientDetails?.patient_id) {
      dispatch(fetchTransactionHistory(patientDetails.patient_id));
    }
  }, [dispatch, patientDetails]);

  // const formatDate = (dateString) => {
  //   if (!dateString) return "-";
  //   const formatted = new Date(dateString.replace(" ", "T"));
  //   return formatted.toLocaleDateString("en-GB", {
  //     day: "2-digit",
  //     month: "short",
  //     year: "numeric",
  //   });
  // };
  const handleDownloadReceipt = async (url, paymentId) => {
    try {
      setDownloadingId(paymentId);
      const link = document.createElement("a");
      link.href = url;
      link.download = "receipt.pdf";
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Failed to download receipt:", error);
    } finally {
      setTimeout(() => setDownloadingId(null), 1000); // Hide loader after 1s
    }
  };


  return (
   

      <div className="card shadow-none"style={{marginTop:"2rem"}}>
        

        <div className="px-3">
          <ul className="list-unstyled">
            {Array.isArray(transactions) && transactions.length > 0 ? (
              transactions.map((txn) => (
                <li
                  key={txn.payment_id}
                  className="border rounded-lg px-4 py-3 mb-3 shadow-sm"
                >
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <div className="fw-bold">Payment For: {txn.payment_for}</div>
                      <div className="text-sm">Payment Type: {txn.payment_type}</div>
                    
                      <div className="fw-semibold text-primary">
                        Amount: ₹{Number(txn.amount).toFixed(2)}
                      </div>
                    </div>
                    <div className="text-end">
                      <div className="text-muted text-sm">{formatDate(txn.date)}</div>
                      {txn.receipt_download_link && (
                        <div className="mt-2">
                          <img
                            src={pdfIcon}
                            alt="Download PDF"
                            width={32}
                            height={32}
                            style={{ cursor: "pointer" }}
                            title="Download Receipt"
                            onClick={() =>
                              handleDownloadReceipt(txn.receipt_download_link, txn.payment_id)
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </li>
              ))
            ) : (
              <li className="text-center text-muted py-4">
                Transaction History not found.
              </li>
            )}
          </ul>
        </div>

      </div>
 
  );
};

export default TransactionHistory;
